module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_8011.9ab297a4.png";